'use client'

import { Box, GridLegacy as Grid, Skeleton, Stack } from '@mui/material'

import type React from 'react'

export const VendorHeaderSkeleton: React.FC = () => {
  return (
    <Grid container spacing={4}>
      <Grid item xs={12} md={9}>
        <Skeleton
          variant="rectangular"
          sx={{
            height: 260,
            borderRadius: 2,
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <Box>
          <Skeleton variant="text" sx={{ fontSize: '2.125rem', mb: 2 }} width="80%" />

          <Stack spacing={1}>
            <Skeleton variant="text" sx={{ fontSize: '0.875rem' }} width="100%" />
            <Skeleton variant="text" sx={{ fontSize: '0.875rem' }} width="70%" />
          </Stack>

          <Stack sx={{ mt: 2 }} spacing={1}>
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              <Skeleton variant="text" width={80} height={20} />
              <Skeleton variant="text" width={80} height={20} />
            </Box>
          </Stack>

          <Stack spacing={1} direction="row" marginTop={1} alignItems="center">
            <Skeleton variant="text" width="100%" height={16} />
          </Stack>

          <Stack marginTop={0.5} spacing={1} direction="row" alignItems="center">
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="text" width="80%" height={16} />
          </Stack>

          <Stack sx={{ mt: 2 }}>
            <Skeleton variant="text" width={120} height={32} sx={{ mb: 1 }} />
            <Skeleton variant="text" width={140} height={32} />
          </Stack>
        </Box>
      </Grid>
    </Grid>
  )
}
